export default __webpack_public_path__ + "static/media/iimg1.de65a878.png";